import React, { useMemo } from 'react';

// Components
import ComparisonItemSelectorUI from '@/views/containers/comparison/ComparisonItemSelector/ComparisonItemSelectorUI';

// Types
import ComparisonItem from '@/types/comparison-item';

// Utils
import { formatLocalizedString } from '@/utils/i18n';

interface TaxAnalysisItemSelectorProps {
  addLabel?: string;
  availableComparisonItems: ComparisonItem[];
  onRemoveItem: (isOriginal: boolean) => void;
  onSelectItem: (item: ComparisonItem, isOriginal: boolean) => void;
  onEditItem?: (isOriginal: boolean) => void;
  isOriginal: boolean;
  selectedItem?: ComparisonItem;
  otherSelectedItem?: ComparisonItem;
  readOnly?: boolean;
}

const TaxAnalysisItemSelector: React.FC<TaxAnalysisItemSelectorProps> = ({
  addLabel = 'Comparison.AddToCompare',
  availableComparisonItems,
  onRemoveItem,
  onSelectItem,
  onEditItem,
  isOriginal,
  selectedItem,
  otherSelectedItem,
  readOnly,
}) => {
  const formattedItemName = useMemo(() => (selectedItem ? formatLocalizedString(selectedItem.name) : ''), [selectedItem]);

  const hasNoItems = !availableComparisonItems.length;
  const isSelectDisabled = hasNoItems;

  const availableOptions = useMemo(() => {
    const options =
      availableComparisonItems?.map(option => ({
        value: option._id,
        label: formatLocalizedString(option.name),
      })) || [];

    return options.filter(option => option.value !== otherSelectedItem?._id);
  }, [availableComparisonItems, otherSelectedItem?._id]);

  return (
    <ComparisonItemSelectorUI
      addLabel={addLabel}
      availableOptions={availableOptions}
      formattedItemName={formattedItemName}
      isSelectDisabled={isSelectDisabled}
      onEditItem={onEditItem ? () => onEditItem(isOriginal) : undefined}
      onRemoveItem={() => onRemoveItem(isOriginal)}
      onSelectItem={(item: ComparisonItem) => onSelectItem(item, isOriginal)}
      selectedItem={selectedItem}
      isOriginal={isOriginal}
      availableComparisonItems={availableComparisonItems}
      readOnly={readOnly}
    />
  );
};

export default TaxAnalysisItemSelector;
